module.exports = __webpack_public_path__ + "static/media/Web capture_mmreview.b54b4614.jpeg";